module.exports = __webpack_public_path__ + "static/sharescrollpos-af24052410258fc93d4e0e6735cb4050.png";